var modules_3717c142 = {"container":"Link_module_container__a0c4cfa2","color-blue":"Link_module_colorBlue__a0c4cfa2","color-gray":"Link_module_colorGray__a0c4cfa2","color-dark":"Link_module_colorDark__a0c4cfa2","strong":"Link_module_strong__a0c4cfa2"};
import "../../../assets/esm/components/Typography/src/Link~u4hWfMOT.css";

export { modules_3717c142 as default };
//# sourceMappingURL=Link.module.less.js.map
